// extracted by mini-css-extract-plugin
export default {"container":"ThankYou_container__Sbqoa","title":"ThankYou_title__fbD6d","thankYouIcon":"ThankYou_thankYouIcon__+FS4-"};